import $ from "cash-dom";
import './ppc';
import "./parts/ppc/pg/results-loading";
import PetInfoForm from './forms/PetInfoForm';

$(function () {
	const petInfoForm = new PetInfoForm();
	petInfoForm.handle();
});